import * as React from 'react';

interface Props {
	answer: string;
	questions: { [name: string]: string; }[];
	declinedQuestionNames: string[];
}

const ReproductiveQuestionAnswer: React.StatelessComponent<Props> = (props) => {
	const reproductiveAnswer = JSON.parse(props.answer);

	const noneKey = 'reproductiveNone';
	const displayNone = reproductiveAnswer[noneKey];

	const abnormalMammogram = 'abnormalMammogram';
	const abnormalMammogramRepeat = 'abnormalMammogramRepeat';
	const breastImagingTestOrPAPTest = 'breastImagingTestOrPAPTest';
	const breastImagingTestOrPAPTestRepeat = 'breastImagingTestOrPAPTestRepeat';
	const abnormalPSATest = 'abnormalPSATest';
	const abnormalPSATestRepeat = 'abnormalPSATestRepeat';
	const abnormalBiopsy = 'abnormalBiopsy';
	const reproductiveDisorderOther = 'reproductiveDisorderOther';
	const reproductiveDisorderOtherDetails = 'reproductiveDisorderOtherDetails';
	return displayNone ? (
		<div>
			None
		</div>
	) : (
		<div>
			{reproductiveAnswer[abnormalMammogram] &&
			<div>
				<dd>Abnormal mammogram or breast imaging</dd>
				<div className={`border border-success`}>
					<dd className={`ml-2`}>Since the original abnormal test, have you had a repeat test that produced normal results?</dd>
					<dd className={`ml-2`}>{reproductiveAnswer[abnormalMammogramRepeat] ? 'Yes' : 'No'}</dd>
				</div>
			</div>}
			{reproductiveAnswer[breastImagingTestOrPAPTest] &&
			<div>
				<br/>
				<dd>Abnormal PAP test</dd>
				<div className={`border border-success`}>
					<dd className={`ml-2`}>Since the original abnormal test, have you had a repeat test that produced normal results?</dd>
					<dd className={`ml-2`}>{reproductiveAnswer[breastImagingTestOrPAPTestRepeat] ? 'Yes' : 'No'}</dd>
				</div>
			</div>}
			{reproductiveAnswer[abnormalPSATest] &&
			<div>
				<br/>
				<dd>Abnormal prostate (PSA) test</dd>
				<div className={`border border-success`}>
					<dd className={`ml-2`}>Since the original abnormal test, have you had a repeat test that produced normal results?</dd>
					<dd className={`ml-2`}>{reproductiveAnswer[abnormalPSATestRepeat] ? 'Yes' : 'No'}</dd>
				</div>
			</div>}
			{reproductiveAnswer[abnormalBiopsy] &&
			<div>
				<br/>
				<dd>Abnormal biopsy</dd>
			</div>}
			{reproductiveAnswer[reproductiveDisorderOther] &&
			<div>
				<br/>
				<dd>Other({reproductiveAnswer[reproductiveDisorderOtherDetails]})</dd>
			</div>}
		</div>
	);
};

export default ReproductiveQuestionAnswer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/QASubComponents/ReproductiveQuestionAnswer.tsx